import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import queryString from 'query-string';
import { checkTokenApi, token2CodeApi, pageDetailApi } from '../../action';
import { AUTH_TOKEN_NAME } from '../../const';
import useEffectOnce from '../../utils/useEffectOnce';
import SsoUploadTrack from '../../utils/ssoUploadTrack';

interface LoginUrlParams {
    id?: string;
    code?: string;
    target?: string;
    [key: string]: any; 
}

const Continue = () => {
    const params: LoginUrlParams = queryString.parse(window.location.search.split('?')[1] || '');
    const navigate = useNavigate();

    useEffectOnce(() => {
        getPageInfo(getCheckToken);
    });

    const handlePostMessage = useCallback((event: string, code: string) => {
        window.parent.postMessage(JSON.stringify({
            from: 'ssoLogin',
            event,
            code
        }), '*');
    }, []);

    // 获取页面信息
    const getPageInfo = useCallback(async (callback: Function) => {
        const { id, target } = params;
        const res = await pageDetailApi({
            id,
            target: encodeURIComponent(target || ''),
            sp: ''
        });
        if (res.data.code === 0) {
            const { t_type } = res.data.data || {};
            if(t_type.includes('v1')){
                window.SSO_TOKEN_VERSION = 'v1';
            }
            if(t_type.includes('v2')){
                window.SSO_TOKEN_VERSION = 'v2';
            }
            callback && callback();
        } else {
            SsoUploadTrack('sso_page_info_error', {
                title: '单点登录子站信息获取失败',
                target_url: params.target || '',
                error_info: res.data.msg
            })
            navigate(`/error?info=子站信息获取失败,联系运维：${res.data.msg}`);
        }
    }, [params]);

    // token子站code
    const getToken2Code = useCallback(async () => {
        const res = await token2CodeApi({
            target: encodeURIComponent(params.target || '')
        });
        if (res.data.code === 0) {
            handlePostMessage('code_success', res.data.data);
        } else {
            SsoUploadTrack('sso_page_continue_token2code_error', {
                title: '单点登录续登token2code失败',
                target_url: params.target || '',
                error_info: res.data.msg
            })
            handlePostMessage('code_error', '');
        }
    }, [params, handlePostMessage]);

    // 检查token
    const getCheckToken = useCallback(async () => {
        const res = await checkTokenApi();
        if (res.data.code === 0) {
            getToken2Code();
        } else {
            SsoUploadTrack('sso_main_token_error', {
                title: '单点登录主站token失效',
                target_url: params.target || '',
                token: localStorage.getItem(`${AUTH_TOKEN_NAME}`) || '',
                error_info: res.data.msg
            })
            handlePostMessage('code_error', '');
        }
    }, [getToken2Code, handlePostMessage]);

    return <div />
};

export default Continue;